import { render, staticRenderFns } from "./allocationStorehouseDetailList.vue?vue&type=template&id=21bf662d&scoped=true"
import script from "./allocationStorehouseDetailList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseDetailList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseDetailList.vue?vue&type=style&index=0&id=21bf662d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf662d",
  null
  
)

export default component.exports